; (function (global, factory) {
	typeof define === 'function' && define.amd ? define('LNRS/Components/Content/Collections/CustomCarousel',["jquery", "eventManager"], factory) :
		typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager")) :
			console && console.error('Carousel does not support non-amd script loading.');
}(this/* window */, function ($, eventManager) {

	function Carousel(scope, carouselId) {
		var self = this;
		Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
		Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope), writable: !1 });
		Object.defineProperty(this, 'lastDirection', { enumerable: !1, value: void 0, writable: !0 });
		Object.defineProperty(this, "$slideTransitionTime", { enumerable: true, value: this.$scope.data('interval') / 1000 + 's', writable: false });


		self.updateCarouselSlidesBackgroundImage();
		self.buildIndicator(carouselId);
		self.fallbackIndicators(carouselId);

		// events
		this.$scope.on('slide.bs.carousel', this._onBeforeChangeSlide.bind(this));
		this.$scope.on('slid.bs.carousel', this._onAfterChangeSlide.bind(this));
		this.$scope.swipe({
			swipeLeft: function () {
				$(this).carousel('next');
			},
			swipeRight: function () {
				$(this).carousel('prev');
			}
		});

		// Choose between mobile or deskop image based on the screen size
		$(window).on("resize", self.updateCarouselSlidesBackgroundImage);

		this.$scope.on('click', '.carousel-indicators li', (e) => {
			e.stopPropagation();
			e.preventDefault();

			const $indicator = $(e.currentTarget);
			if ($indicator.hasClass('active') && !$indicator.hasClass('paused')) {
				self.pauseCarousel();
				$indicator.addClass('paused');
			} else if ($indicator.hasClass('paused')) {
				self.cycleCarousel();
				$indicator.removeClass('paused');
			} else {
				const slideTo = parseInt($indicator.data('slide-to'), 10);
				if (!isNaN(slideTo)) {
					this.$scope.carousel(slideTo);
					// in case it was paused
					self.cycleCarousel();
				}
			}
		});


		// Set indicator animation interval
		this.$scope[0].style.setProperty('--carousel-interval', this.$slideTransitionTime);

		// set the first slide to be active
		this.$scope.find('.item:first-of-type').addClass("active");

		// add color opacity
		this.$scope.find('div[style*=background-color]').each((index, element) => {
			let color = element.style.backgroundColor;
			element.style.backgroundColor = color.replace('rgb', 'rgba').replace(')', ', .85)');
		});

		// start the carousel
		let data = this.$scope.data();
		this.$scope.carousel(data);
	}

	Carousel.prototype.pauseCarousel = function () {
		this.$scope.carousel('pause');
	};

	Carousel.prototype.cycleCarousel = function () {
		this.$scope.carousel('cycle');
	};

	Carousel.prototype.updateCarouselSlidesBackgroundImage = function () {
		var screenWidth = $(window).width();

		$('.carousel-inner .item', this.$scope).each(function () {
			var $item = $(this);
			var desktopImage = $item.data("desktop-image");
			var mobileImage = $item.data("mobile-image");

			var bgImage = screenWidth <= 768 ? mobileImage : desktopImage;
			$item.css("background-image", "url('" + bgImage + "')");
		});
	}


	Carousel.prototype.buildIndicator = function (carouselId) {
		var carouselPaneItems = $('.carousel-inner .item', this.$scope).get();

		if (carouselPaneItems.length > 1) {
			var slides = carouselPaneItems.map(function (el, i) {
				var imgSrc = $(el).data('indicator-image');
				var headlineValue = $('.carousel-pane-headline', el).text();
				return `<li data-target="#${carouselId}" data-slide-to="${i}" ${!i ? 'class="active"' : ''}>
				<div class="wrapper">
					<img src="${imgSrc}" alt="Slide ${i + 1}" class="carousel-thumb">
					<div class="progress-ring">
						<svg class="progress-ring-svg" width="70" height="70" viewBox="0 0 70 70" preserveAspectRatio="xMidYMid meet">
							<circle cx="35" cy="35" r="34"></circle>
						</svg>
						<div class="progress-bar"></div>
					</div>
					<div class="indicator-tooltip">${headlineValue}</div>
				</div>
            </li>`;
			}).join("");

			this.$scope.prepend(`<div class="carousel-indicators"><ol>${slides}</ol></div>`);
		}
	}

	Carousel.prototype.fallbackIndicators = function (carouselId) {
		var $carousel = this.$scope;
		var id = carouselId;
		var relatedIndicators = $('li[data-target="#' + id + '"]', this.$scope);
		$carousel.on('slid.bs.carousel', function (e) {
			var index = $carousel.find('.carousel-inner .item').index($carousel.find('.carousel-inner .active'));
			relatedIndicators.removeClass('active');
			relatedIndicators.filter('[data-slide-to="' + index + '"]').addClass('active');
		});
	}

	Carousel.prototype._onBeforeChangeSlide = function (e) {
		this.lastDirection = e.direction;
		$(this).trigger('beforeChange.slider', [this, e.direction]);
	}

	Carousel.prototype._onAfterChangeSlide = function (e) {
		this.lastDirection = e.direction;
		$(this).trigger('afterChange.slider', [this, e.direction]);
		this.$scope.find('.carousel-indicators li').removeClass('paused');
	}

	Carousel.init = function (args) {
		if (args.IsEditorEditing) return null;

		var carousel = new Carousel(args.scope, args.CarouselId || []);

		return carousel;
	}

	return Carousel;
}));

